module.exports = __webpack_public_path__ + "static/media/Rosalind R.8ea94829.png";